module.exports = __webpack_public_path__ + "359e8a86d4dc25811206ae7f768cd3ec.svg";